import React from 'react';

// "Applies to machines where": label is value pairs. Every pair must match a label on the machine (VES labels).
//   locked  nothing can be changed: the pairs are shown and that is all (a software policy keeps its filter for life)
//   fixed   how many pairs at the start are kept as they are and cannot be removed (the account pair of a new software policy)
export default function FilterField({ field, value, onChange, listId, locked = false, fixed = 0 }) {
  const pairs = value && value.length ? value : [{ label: '', value: '' }];
  const set = (index, patch) => onChange(pairs.map((p, i) => (i === index ? { ...p, ...patch } : p)));
  return (
    <div className="repeat">
      {(field.commonLabels || []).length > 0 && (
        <datalist id={listId}>{field.commonLabels.map((l) => <option key={l} value={l} />)}</datalist>
      )}
      {pairs.map((p, i) => {
        const kept = locked || i < fixed;
        return (
          <div className="repeat-row filter-row" key={i}>
            <input type="text" aria-label={`Label ${i + 1}`} list={listId} placeholder="label, for example devicetype" value={p.label} readOnly={kept} onChange={(e) => set(i, { label: e.target.value })} />
            <span className="repeat-is">is</span>
            <input type="text" aria-label={`Value ${i + 1}`} placeholder="value, for example workstation" value={p.value} readOnly={kept} onChange={(e) => set(i, { value: e.target.value })} />
            {!locked && <button type="button" className="btn btn-ghost btn-sm" aria-label={`Remove pair ${i + 1}`} disabled={kept || pairs.length === 1} onClick={() => onChange(pairs.filter((_, j) => j !== i))}>Remove</button>}
          </div>
        );
      })}
      {!locked && <button type="button" className="btn btn-sm" onClick={() => onChange([...pairs, { label: '', value: '' }])}>Add a label</button>}
      {locked && <div className="help">The labels of a software policy cannot be changed once it is made. To apply rules to other machines, make a new policy.</div>}
    </div>
  );
}
